import React, { Component, useRef, useState, useEffect } from 'react';
import {Link} from "react-router-dom";
import { Helmet } from 'react-helmet-async';

import NavMenu from './NavMenu';
import * as utils from './Utils.js'

const FAQ = () => {
  useEffect(() => {
  }, [])

  return (
    <div className="FAQ">
      <Helmet>
        <title>FAQ</title>
        <meta
          name="description"
          content="Find answers to your questions about the wedding weekend!"
        />

        <meta property="og:title" content="FAQ | Chandler & Anna" />
        <meta
          property="og:description"
          content="Find answers to your questions about the wedding weekend!"
        />
        <meta
          property="og:image"
          content="https://chandlerandanna.com/og/faq.jpg"
        />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="400" />
        <meta property="og:url" content="https://chandlerandanna.com/faq" />

        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <div className='centered-box wedding-page-block'>
        <div className='wedding-centerpiece'>
          <p className='wedding-page-title'>FAQ</p>
          <div className='faq-section'>
            <div className='faq-question-and-answer'>
              <p className='faq-question'>Can I bring a guest?</p>
              <p className='faq-answer'>Only guests specifically addressed on your invitation are invited.</p>
            </div>

            <div className='faq-question-and-answer'>
              <p className='faq-question'>What if I'm not Catholic?</p>
              <p className='faq-answer'>We're excited for everyone to celebrate our wedding mass with us! If you aren't Catholic, you can receive a blessing instead of communion during the mass by crossing your arms over your chest.</p>
            </div>

            <div className='faq-question-and-answer'>
              <p className='faq-question'>What is the dress code?</p>
              <p className='faq-answer'>The ceremony and reception are Black Tie. For men, tuxedos are preferred. For women, full length dresses or pants. Please note that it can be chilly in April, so bring a jacket.</p>
              <p className='faq-answer'>The Welcome Party at Gardiner House is dressy casual. For guests invited to the Rehearsal Dinner, the dress code is formal.</p>
            </div>

            <div className='faq-question-and-answer'>
              <p className='faq-question'>What is the best way to get to Newport, RI?</p>
              <p className='faq-answer'>For information on getting to Newport, RI, see the <Link to="/hotel-and-travel" className='link-to-page'>Hotel & Travel</Link> page.</p>
            </div>

            <div className='faq-question-and-answer'>
              <p className='faq-question'>Will there be transportation provided?</p>
              <p className='faq-answer'>There will be shuttles at each venue to transport guests. If you are driving, there are parking lots at all venues: Gardiner House, St. Mary's Church, and Castle Hill Inn.</p>
            </div>

            <div className='faq-question-and-answer'>
              <p className='faq-question'>What time should I arrive at the ceremony?</p>
              <p className='faq-answer'>Please arrive at least 20 minutes before the ceremony starts to find your seat.</p>
            </div>

            <div className='faq-question-and-answer'>
              <p className='faq-question'>What is there to do in Newport, RI?</p>
              <p className='faq-answer'>We've compiled a list of our favorite <Link to="/things-to-do" className='link-to-page'>Things To Do</Link> in Newport for you to check out!</p>
            </div>
          </div>
        </div>
      </div>

      <div className='centered-box'>
        { utils.displayCheckerboard(20, 42, ['seersucker-blue', 'ivory']) }
      </div>
    </div>
  );
}

export default FAQ;
